import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const kubernetes = defineConnector({
  identifier: "kubernetes",
  name: "Kubernetes",
  tagLine: "Container orchestration platform",
  keywords: "k8s kubectl cluster pods namespaces containers rbac",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ host }) => domainToRegex(host),
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API server details",
      items: [
        {
          kind: "markdown",
          content:
            "You'll need access to your Kubernetes API server. Run `kubectl cluster-info` to find your API server URL, and create a service account token for authentication.",
        },
      ],
    },
    {
      title: "Enter your cluster details",
      items: [
        {
          kind: "url",
          label: "API server URL",
          placeholder: "https://my-cluster.example.com",
          required: true,
          target: { kind: "configuration", field: "host" },
          helperText:
            "The URL of your Kubernetes API server, including any path it’s served under.",
        },
        {
          kind: "input",
          label: "Bearer token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText:
            "A service account bearer token with appropriate RBAC permissions.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `${host}/api/v1/namespaces`,
  },
});
